import { Fragment } from 'react'
import { Typography } from '@mui/material'

export const TextWithLineBreaks: React.FC<{
  text: string
  textAlign?: 'justify' | 'left' | 'right'
}> = ({ text, textAlign = 'justify' }) => {
  return (
    <Typography sx={{ textAlign }} variant="body2">
      {text.split('\n').map((line, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      ))}
    </Typography>
  )
}
